import smartSolveApi from './instances/smartsolve';

export const getTranslatedColumnList = async ({
  entityName,
  savedSearchName,
  customFilter,
  queryForDocRepository = false,
}) => {
  try {
    const response = await smartSolveApi.post('/getTranslatedColumnList', {
      entityName,
      savedSearchName,
      filter: customFilter,
      queryForDocRepository,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getTranslatedColumnList() failed: ${e}`);
  }
};
